import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';

@createModule('SearchTrigger')
/**
 * search-trigger module implementation.
 *
 * @author Heiko Frosch <heiko.frosch@namics.com>
 */
export class SearchTrigger extends TerrificSpec {
	searchFlyoutIsOpen: boolean = false;
	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: Function) {
		const $ctx = $(this._ctx);

		$($ctx)
			.find('.js-search-trigger')
			.on('click', this._handleTrigger.bind(this));

		$(window).on('searchFlyout:close', this._close.bind(this));
		resolve();
	}
	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}
	/**
	 * method to trigger public event
	 *
	 * @returns {void}
	 */
	_triggerChangeEvent() {
		triggerPublicEvent(PublicEvents.uxChange, this, this._ctx);
	}

	_close() {
		//toggle icon
		$('.js-search-trigger').removeClass('a-search-trigger__item-link--active');
		$(window).trigger('modalWindow:close');
		//apply header z-index Fix
		$('.o-header').removeClass('o-header--alter-zindex');
		this.searchFlyoutIsOpen = false;
	}

	_handleTrigger(ev: Event) {
		if (this.searchFlyoutIsOpen === true) {
			//hide flyout
			$(window).trigger('searchFlyout:close');
		} else {
			$(window).trigger('modalWindow:open');

			//apply header z-index Fix
			$('.o-header').addClass('o-header--alter-zindex');

			//hide flyout
			$('.js-flyout-container').addClass('m-search-flyout--active');

			//toggle icon
			$('.js-search-trigger').addClass('a-search-trigger__item-link--active');

			$(window).trigger('searchFlyout:open');

			this.searchFlyoutIsOpen = true;
		}

		ev.preventDefault();
	}
}
